export default "__VITE_ASSET__ofLXbDne__"